function getSplitComplementaryColors(color: string) {
  // Normalize input color using <canvas>
  function parseColor(input: string) {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx!.fillStyle = input;
    return ctx!.fillStyle;
  }

  function hexToHSL(hex: string) {
    hex = hex.replace("#", "");
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }

    const r = parseInt(hex.slice(0, 2), 16) / 255;
    const g = parseInt(hex.slice(2, 4), 16) / 255;
    const b = parseInt(hex.slice(4, 6), 16) / 255;

    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h = 0;
    let s = 0;
    const l = (max + min) / 2;

    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h *= 60;
    }

    return { h, s: s * 100, l: l * 100 };
  }

  function hslToHex(h: number, s: number, l: number) {
    s /= 100;
    l /= 100;
    const k = (n: number) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) =>
      Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))));
    return `#${[f(0), f(8), f(4)]
      .map((x) => x.toString(16).padStart(2, "0"))
      .join("")}`;
  }

  // Main logic
  const hex = parseColor(color);
  const hsl = hexToHSL(hex);
  const h1 = (hsl.h + 150) % 360;
  const h2 = (hsl.h + 210) % 360;

  return [hslToHex(h1, hsl.s, hsl.l), hslToHex(h2, hsl.s, hsl.l)];
}

function generatePossibleColors() {
  const style = window.getComputedStyle(document.body);
  const backgroundColor = style.getPropertyValue("--fill-brand");

  const splitComplementaryColors = getSplitComplementaryColors(backgroundColor);

  return splitComplementaryColors.flatMap((secondColor) => {
    const result = [];

    for (let i = 50; i < 80; i += 5) {
      result.push(`color-mix(in hsl, var(--fill-brand), ${secondColor} ${i}%)`);
    }

    return result;
  });
}

export const possibleUserColors = generatePossibleColors();

export function getNumberBasedOnId(id: string): number {
  if (!id.length) return 0;

  // DJB2 hash — mixes all characters so distribution is good
  // regardless of UUID version (v4 random vs v7 timestamp-prefixed)
  let hash = 5381;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) + hash + id.charCodeAt(i)) | 0;
  }

  return Math.abs(hash) % possibleUserColors.length;
}
